import { gql } from '@apollo/client'
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core'

import { HandleSupplierDirectoryTextTradeRelationshipFragmentDoc } from './HandleSupplierDirectoryTextTradeRelationship.generated'
import { PurchasePlusPageInfoFragmentDoc } from './PageInfo.generated'
import * as Types from './purchasePlus_graphql'

export const GetAccountsPayableSystemSuppliersDocument = gql`
  query GetAccountsPayableSystemSuppliers(
    $after: String
    $before: String
    $first: Int
    $filters: SuppliersQueryFiltersInput
    $last: Int
    $sorts: [SuppliersQuerySortsInput!]
    $accountsPayableSystemId: Int
  ) {
    accountsPayableSystem(id: $accountsPayableSystemId) {
      id
      suppliers(after: $after, before: $before, first: $first, last: $last, sorts: $sorts, filters: $filters) {
        edges {
          node {
            id
            name
            isVerified
            legalEntity
            businessNumber
            email
            telephone
            creditApplicationUrl
            owner {
              id
              name
            }
            parent {
              id
              name
            }
            supplierRelationship {
              id
              ...HandleSupplierDirectoryTextTradeRelationship
              preferredSupplier
              supplierNumber
              supplierLocationCode
              isSelfManagedCataloguesAllowed
              status
            }
          }
        }
        pageInfo {
          ...PurchasePlusPageInfo
        }
      }
    }
  }
  ${HandleSupplierDirectoryTextTradeRelationshipFragmentDoc}
  ${PurchasePlusPageInfoFragmentDoc}
` as unknown as DocumentNode<
  Types.GetAccountsPayableSystemSuppliersQuery,
  Types.GetAccountsPayableSystemSuppliersQueryVariables
>
